import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// 导入vant
import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);

import Mint from 'mint-ui';
import 'mint-ui/lib/style.css'
Vue.use(Mint);





// REM
import 'amfe-flexible';

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
